/**
 * Shared identifiers/styling for additional-asset tabs, used by both the page
 * (for tab values, content panels, and dot mapping) and the overflow tab bar.
 */

// Additional-asset tabs are keyed by their relative path, namespaced under this
// prefix so they never collide with the fixed ProjectTab values.
export const ADDITIONAL_TAB_PREFIX = "additional:";

/** The tab `value` for an additional asset at `path`. */
export const additionalTabValue = (path: string): string =>
  `${ADDITIONAL_TAB_PREFIX}${path}`;

// Shared styling for a tab trigger (matches the fixed asset tabs) so the
// dynamically-rendered additional-asset tabs stay visually consistent.
export const TAB_TRIGGER_CLASS =
  "relative flex flex-none items-center gap-2 px-4 py-3 data-[state=active]:bg-background dark:data-[state=active]:bg-background data-[state=active]:border-b-2 data-[state=active]:border-blue-600 dark:data-[state=active]:border-blue-500 data-[state=active]:text-blue-600 dark:data-[state=active]:text-blue-400 data-[state=active]:border-l-0 data-[state=active]:border-r-0 data-[state=active]:border-t-0 rounded-none [&[data-state=active]>svg]:text-blue-600 dark:[&[data-state=active]>svg]:text-blue-400";
